// extracted by mini-css-extract-plugin
export default {"wrapper":"OfferValueCell_wrapper__u6XoV"};